// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__2mkwn","spinner":"Spinner_spinner__BqS3J"};